
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import DutySettingsModal from "./DutySettingsModal";

@Component({
  name: 'DutySettingsButton',
  components: {
    DutySettingsModal,
  }
})
export default class DutySettingsButton extends Vue {
  open(): void {
    (this.$refs.modal as DutySettingsModal).open();
  }
}
